import config from '../frontend/config';

export const checkIsAdmin = () => {
  let isAdmin = false;

  try {
    if (window.Shopify.PreviewBarInjector) {
      isAdmin = true;
    }

    if (window.Shopify.AdminBarInjector) {
      isAdmin = true;
    }
  } catch (e) {}

  return isAdmin;
}

export const checkIsVisibleBrowserTab = () => {
  let check = (function () {
    var stateKey, eventKey, keys = {
      hidden: "visibilitychange",
      webkitHidden: "webkitvisibilitychange",
      mozHidden: "mozvisibilitychange",
      msHidden: "msvisibilitychange"
    };
    for (stateKey in keys) {
      if (stateKey in document) {
        eventKey = keys[stateKey];
        break;
      }
    }
    return function (c) {
      if (c) document.addEventListener(eventKey, c);
      return !document[stateKey];
    }
  })();
  return check();
}

export const checkIsMobile = () => {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
}

export const hash = function(s) {
  /* Simple hash function. */
  var a = 1, c = 0, h, o;
  if (s) {
      a = 0;
      /*jshint plusplus:false bitwise:false*/
      for (h = s.length - 1; h >= 0; h--) {
          o = s.charCodeAt(h);
          a = (a<<6&268435455) + o + (o<<14);
          c = a & 266338304;
          a = c!==0?a^c>>21:a;
      }
  }
  return String(a);
}

/**
 * Get cookie by name
 *
 * @param {string} name
 * @return {string|undefined}
 */
export const getCookie = function(name) {
    let cookie = {};

    document.cookie.split(';').forEach(function(el) {
        let [k,v] = el.split('=');
        cookie[k.trim()] = v;
    })

    return cookie[name];
}

/**
 *
 * @param {string} name
 * @param {string} value
 * @param {number} exDays
 */
export const setCookie = function(name, value, exDays)
{
    let date = new Date();
    date.setTime(date.getTime() + (exDays*24*60*60*1000));

    let expires = "expires="+ date.toUTCString();

    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

/**
 * Check page is valid
 *
 * @param {string|null} page
 * @return {boolean}
 */
export const isValidPage = function(page) {
  const pages = [
    'index', 'product', 'collection', 'cart',
    'list-collections', 'page.alireviews-widget',
  ];

  if (pages.includes(page)) {
    return true;
  }

  // Page template in Gempages, and Pagefly
  return page && (
    page.startsWith('index')
    || page.startsWith('product')
    || page.startsWith('collection')
  );
}

/**
 * @param {string} text
 */
export function copyToClipboard(text) {
  if (window.clipboardData && window.clipboardData.setData) {
    return window.clipboardData.setData("Text", text);
  }
  else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
    var textarea = document.createElement("textarea");
    textarea.textContent = text;
    textarea.style.position = "fixed";
    document.body.appendChild(textarea);
    textarea.select();
    try {
      return document.execCommand("copy");
    }
    catch (ex) {
      console.warn("Copy to clipboard failed.", ex);
      return false;
    }
    finally {
      document.body.removeChild(textarea);
    }
  }
}

export function appendJS(cdn) {
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.defer = true;
    script.src = cdn;
    document.body.appendChild(script);
}
export function onChangeClassHtml(callback) {
    const nodeHtml = document.querySelector('html')
    function checkCondition(mutationsList, observer) {
      mutationsList.forEach(mutation => {
        if (mutation.attributeName === 'class') {
          var isTranslated = false;
          nodeHtml.classList.forEach(item=>{
            if(item.indexOf('translated') != -1){
              isTranslated = true;
            }
          })
          if(isTranslated){
            callback();
          }
        }
      })
    }
    const mutationObserver = new MutationObserver(checkCondition)
    mutationObserver.observe(nodeHtml, { attributes: true })
}
export function getValueParamURL(param) {
    const url = new URL(window.location.href);
    return url.searchParams.get(param);
}

export function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export function validateInput(element, val, isEmail) {

  element.removeClass('invalid valid');
  element.addClass((isEmail ? validateEmail(val) : val) ? 'valid' : 'invalid');
}

export function validateWriteReviewForm() {
  $('#your_name').on('input', function () {
    if ($(this).val().length >= 50) {
      $(this).val($(this).val().substr(0, 49));
    }
    validateInput($(this), $(this).val());
  });
  
  $('#content, [name="content"]').on('input', function () {
    const parentEL = $(this).closest('.alireview-input-textarea');
    const countContentEL = parentEL.find('#count-content');
    const val = $(this).val();

    // if (val.length > 2000) {
    //     $(this).val(val.substr(0, 1999));
    // }
    countContentEL.html(`${val.length}/2000`);
    $(this).attr('id') !== 'questionField' && validateInput(parentEL, val);
  });

  $('#content').on('focus', function () {
    const countContentEL = $(this).closest('.alireview-input-textarea');

    validateInput(countContentEL, $(this).val());
  });

  $('#your_name').on('focus', function () {
    validateInput($(this), $(this).val());
  });
  
  $('#your_email').on('focus', function () {
    validateInput($(this), $(this).val(), true);
  });

  $('#your_email').on('input', function () {
    validateInput($(this), $(this).val(), true);
  });
}

export function renderLikeUnlikeAction(type, domain) {
  const dataActions = JSON.parse(localStorage.getItem(`${domain}_actions`));

  if (dataActions) {
    const itemSelector = type === 'review' ? '[data-comment_id]' : `[data-qna_id][data-qna_type="${type}"]`;
    const listActionEl = [...document.querySelectorAll(itemSelector)]
    const elHasAction = listActionEl.filter((item) => {
      let actionUser = item.getAttribute('data-react_type') === 'like' ? 1 : 0,
        id = item.getAttribute('data-comment_id') || item.getAttribute('data-qna_id');

      return dataActions[type]?.includes(`${id}_${actionUser}`);
    });

    elHasAction.forEach((item, index) => {
      item.classList.add('active');
    });
  }
}

export function storeActionLikeUnlike({ domain, id, action, type, currentTotal, total }) {
  let dataActions = JSON.parse(localStorage.getItem(`${domain}_actions`) || '{}'),
      dataOfType = dataActions?.[type] || [];

  action = total > currentTotal ? (action === 'like' ? 1 : 0) : '';
  const strItem = `${id}_${action}`;

  if (dataOfType.length) {
      const currentItemIdx = dataOfType.findIndex(item => {
          return (item || '').split('_')[0] === id.toString();
      });

      if (currentItemIdx > -1) {
          dataOfType[currentItemIdx] = strItem;
      } else {
          dataOfType[dataOfType.length] = strItem;
      }
  } else {
      dataActions = {
          ...dataActions,
          [type]: [strItem]
      };
  }
  localStorage.setItem(`${domain}_actions`, JSON.stringify(dataActions));
}

export function handleLikeUnlike(_this, domainName, url, type, payload) {
  const target = $(_this),
    commentId = target.attr("data-comment_id") || payload?.qna_id,
    reactType = target.attr("data-react_type") || payload?.react_type,
    parentEl = _this.closest('div'),
    likeEl = $(parentEl.querySelector('.alireview-comment-like') || parentEl.querySelector('span[class*="like"]')),
    unLikeEl = $(parentEl.querySelector('.alireview-comment-unlike') || parentEl.querySelector('span[class*="unlike"]')),
    isLike = reactType === 'like';

    domainName = domainName || target.attr('data-shop_domain');
    !target.attr("disabled") && $.ajax({
      method: "PUT",
      url,
      data: payload ? payload : {
        shop_domain: domainName,
        comment_id: commentId,
        react_type: reactType
      },
      beforeSend: function () {
        likeEl.attr("disabled", true);
        unLikeEl.attr("disabled", true);
      },
      success: function (res) {
        let totalLike = !type ? res?.data?.total_like : res?.data?.total_likes,
          totalUnlike = !type ? res?.data?.total_unlike : res?.data?.total_dislikes,
          totalNew = isLike ? totalLike : totalUnlike,
          numberLikeEl = $(parentEl).find('.alireview-number-like'),
          numberUnLikeEl = $(parentEl).find('.alireview-number-unlike');

        numberLikeEl = numberLikeEl.length ? numberLikeEl : likeEl.find('span');
        numberUnLikeEl = numberUnLikeEl.length ? numberUnLikeEl : unLikeEl.find('span');

        let currentTotal = parseInt(isLike ? numberLikeEl.text() : numberUnLikeEl.text()) || 0;

        totalLike = totalLike > 0 ? totalLike : 0;
        totalUnlike = totalUnlike > 0 ? totalUnlike : 0;
        storeActionLikeUnlike({
          domain: domainName,
          id: commentId,
          action: reactType,
          type: type || 'review',
          currentTotal: currentTotal,
          total: isLike ? totalLike : totalUnlike,
        });

        likeEl.attr("disabled", false);
        unLikeEl.attr("disabled", false);
        likeEl.removeClass('active');
        unLikeEl.removeClass('active');
        numberLikeEl.text(` ${totalLike} `);
        numberUnLikeEl.text(` ${totalUnlike} `);

        if (totalNew > currentTotal) {
          isLike ? likeEl.addClass('active') : unLikeEl.addClass('active');
        }
      },
      error: function (err) {
        console.log(err);
        likeEl.attr("disabled", false);
        unLikeEl.attr("disabled", false);
        // alert("An error, please try again.");
      }
  });
}

export function convertMsToMinutesSeconds(milliseconds) {
  const minutes = Math.floor(milliseconds / 60000) || 0,
    seconds = Math.round((milliseconds % 60000) / 1000) || 0;

  return seconds === 60
    ? `${minutes + 1}:00`
    : `${minutes}:${seconds.toString().padStart(2, '0')}`;
}

export async function createThumbnailFromVideoEl(videoEl) {
  const canvas = document.createElement("canvas");

  //here you can set anytime you want
  // videoEl.currentTime = 5;
  canvas.width = videoEl.offsetWidth * 5;
  canvas.height = videoEl.offsetHeight * 5;
  canvas.getContext("2d").drawImage(videoEl, 0, 0, canvas.width, canvas.height);
  
  return await fetch(canvas.toDataURL("image/png"))
    .then(res => res.blob())
    .then(blob => {
      const file = new File([blob], "Thumbnail",{ type: "image/png" });
      
      return file;
    });
}

export async function handleDataToSubmitReviews(formData, filesToUpload, productId) {
  const addFileUploadForData = function (idx, key, value) {
      formData.append(`reviews[${productId}][media][${idx}]${key}`, value);
    };

  formData.append(`reviews[${productId}][product_id]`, productId);
  for (const [index, item] of filesToUpload.entries()) {
    const isPhoto = item.file.name.match(/\.(jpg|jpeg|png|gif)$/i);
        
    addFileUploadForData(index, '[type]', isPhoto ? 'photo' : 'video');
    item.file.size && addFileUploadForData(index, '[url]', item.file.url || '');
    if (!isPhoto) {
      const videoEl = document.querySelector(`video[data-fileid="${item.id}"]`);

      if (videoEl) {
        const thumbnail = await createThumbnailFromVideoEl(videoEl);

        addFileUploadForData(index, '[thumbnail]', thumbnail);
        addFileUploadForData(index, '[metadata][duration]', +$(videoEl.nextSibling).data('duration'));
        addFileUploadForData(index, '[metadata][size]', +item.file.size);
      }
    }
  }
}

export function uuid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export function parseJson(strObj) {
  try {
    return JSON.parse(strObj);
  } catch {
    return false;
  }
};

export const uniqueArr = arr => Array.from(new Set(arr));

export function lazyLoadMedias(mediaEls) {
  const imageDefault = `${config.app_cdn_url}/image/default-review.svg`;

  mediaEls.each((index, itemEl) => {
    const lazyLoadEl = itemEl.closest('.alr-lazy-loading');
    const videoEl = $(itemEl.closest('[data-video]'));
    const srcUrl = itemEl.getAttribute('data-src');
    const onLoaded = () => {
      lazyLoadEl.classList.remove('alr-lazy-loading');
      lazyLoadEl.classList.add('alr-image-loaded');
      // window.dispatchEvent(new Event('updateMasonry'));
    }
    const onLoadMedia = () =>  {
      itemEl.src = srcUrl;    
      itemEl.onerror = () => {
        onLoaded();
        lazyLoadEl.innerHTML = `<img src=${imageDefault} alt="" />`;
        videoEl.removeAttr('data-video');
      }

      itemEl.onloadedmetadata = () => {
        onLoaded();
        videoEl.hasClass('play') ? itemEl.play() : itemEl.pause();
      }
      
      itemEl.onload = () => {
        onLoaded();
      }
    }
    
    if (!lazyLoadEl || !srcUrl) {
      return;
    }

    onLoadMedia();
  });
};

export function lazyLoadImageCarousel(owlCarouselAlireviewEl) {
  const wrapThumbEl = owlCarouselAlireviewEl.find('.alireview-product-img');

  if (!wrapThumbEl.length) {
    return;
  }

  const mediaEls = wrapThumbEl.find('.alr-lazy-loading img');

  lazyLoadMedias(mediaEls);
}